import React, { useState } from 'react'
import { Form, Button, Alert } from "react-bootstrap";
import { serSetAddTimu, serSetBatchAddTimu } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';

export default function Tikuadd() {
  const [inputValue,setInputValue]=useState('')
  const [optionValue,setOptionValue]=useState('')
  const [msgInfo,setMsgInfo]=useState('')
  const {lg}=useSelector((state)=>state.language)

  const handleInputChang=(e) => {
    const reg=/^\d*$/
    if(!reg.test(e.target.value))return;
    setInputValue(e.target.value)
  };

  const handleSelectChang = (e) => {
    setOptionValue(e.target.value)
  };

  const handleAddBtnClick =() => {
    if(msgInfo) return;
    if(!inputValue||!optionValue){
      setMsgInfo(`0${langList.tikuadd1[lg]}`)
      return;
    };
    if(inputValue.length!==81){
      setMsgInfo(`0${langList.tikuadd2[lg]}`)
      return;
    };
    serSetAddTimu({op:optionValue,ti:inputValue})
    .then(res=>{
      const code=res.code;
      if(code===51){
        setMsgInfo(`1${langList.tikuadd3[lg]}`);
      }else{
        setMsgInfo(`0${langList.screening20[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    })
  };

  const handleBatchBtnClick =() => {
    serSetBatchAddTimu({op:optionValue})
    .then(res=>{
      const code=res.code;
      if(code===52){
        setMsgInfo(`1${langList.tikuadd4[lg]}`);
      }else{
        setMsgInfo(`0${langList.tikuadd5[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    })
  };

  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )
  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };


  return (
    <div className='my-4'>
      <Form.Select id='selecttikuadd' className='mt-3'
        value={optionValue} onChange={handleSelectChang}
      >
        <option value=''>{langList.tikuadd6[lg]}</option>
        <option value='1'>{langList.buttbar1[lg]}</option>
        <option value='2'>{langList.buttbar2[lg]}</option>
        <option value='3'>{langList.buttbar3[lg]}</option>
        <option value='4'>{langList.buttbar4[lg]}</option>
        <option value="5">{langList.buttbar5[lg]}</option>
      </Form.Select>
      <Form.Control id='buttbar' as="textarea" rows={3} type="text"
      placeholder={langList.tikuadd7[lg]} value={inputValue} className='mt-3'
      onChange={handleInputChang}/>
      <div className='mb-2'>{langList.tikuadd8[lg]}{inputValue.length}</div>
      {msgInfo && chip}
      <div className='mt-3 d-flex justify-content-between '>
        <Button variant="primary"
          onClick={handleAddBtnClick}>{langList.crsytal10[lg]}</Button>
        <Button variant="primary"
          onClick={handleBatchBtnClick}>{langList.tikuadd9[lg]}</Button>
      </div>
    </div>
  );
}
